module.exports = __webpack_public_path__ + "static/img/loading-red.8f91d88c.svg";